<template>
  <b-nav-text>
    <span :class="envClass">{{envName}}</span>&nbsp;<span class="version">{{GAME_VERSION}} ({{REVISION_HASH}})</span>
  </b-nav-text>
</template>

<script>
import { IS_DEV        } from '../autogen/version';
import { GAME_VERSION  } from '../autogen/version';
import { REVISION_HASH } from '../autogen/version';

export default {
  name: 'InsiderVersion2',

  data() {
    return {
      IS_DEV,
      GAME_VERSION,
      REVISION_HASH,
    };
  },

  computed: {
    envName() {
      return this.IS_DEV ? 'Dev' : 'Production';
    },

    envClass() {
      return {
        dev:   this.IS_DEV,
        prod: !this.IS_DEV,
      };
    },
  },
};
</script>

<style scoped>
.version {
  font-size: small;
  color: white;
  white-space: nowrap;
}

.dev {
  font-size: small;
  color: white;
}

.prod {
  color: #ff0000;
  font-weight: bold;
}
</style>
